import { guidEmpty } from "utils/guid-empty";

export class ClassificacaoModel {
    constructor(
        public id: string = guidEmpty(),
        public abreviacao: string = '',
        public descricao: string = '',
        public categoria: string = '',
    ) { }
}
